import { render, staticRenderFns } from "./IconTime.vue?vue&type=template&id=49228c69&scoped=true"
import script from "./IconTime.vue?vue&type=script&setup=true&lang=js"
export * from "./IconTime.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49228c69",
  null
  
)

export default component.exports